var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('contact-form',{staticClass:"kundenbewertung-form",attrs:{"name":_vm.name,"required-fields":_vm.requiredFields,"button-text":"Bewertung abgeben"}},[_c('contact-fields-kundenbewertung')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }